import { InjectionToken } from '@angular/core';

/* use this ONLY to test in dev mode */
export const DEV_MODE = new InjectionToken<string>('DEV_MODE');

export type NK_PARSER<V> = (expression: string, locale?: string) => V | null;
export type NK_PARSER_DICTIONARY<V> = Map<string, NK_PARSER<V>>;
export type NK_FORMATTER<V> = (value: V, displayFormat: string) => string | null;
